import React from 'react';
import { Fade } from "react-awesome-reveal";
import { Button, H3, Text } from 'atoms';
import { useDispatchUi } from 'context/ui';

interface Props {
    heading: string;
    ctalink?: string;
    ctalabel: string;
    subhead?: string;
    h3FontSize?: string;
    stepUp?: boolean;
}

export const ConversionPanel3 = ({ heading, subhead, ctalabel, ctalink, h3FontSize, stepUp }: Props) => {
    const dispatch: any = useDispatchUi();
    return (
        <div id='panel'>
            <Fade>
                <div id='panel-content'>
                    <H3 style={{ color: '#fff', fontSize: h3FontSize && h3FontSize }}>{heading}</H3>
                    <Text style={{ color: '#fff' }} mt={4} mb={5}>
                        {subhead}
                    </Text>
                    {!stepUp && (
                        <Button
                            href={ctalink ? ctalink : ''}
                            style={{ margin: '0 auto' }}
                            ctaVariant='secondary'
                            onClick={(e: any) => {
                                if (!ctalink) {
                                    e.preventDefault();
                                    dispatch({ type: 'OPEN_MODAL' });
                                }
                            }}
                        >
                            {ctalabel}
                        </Button>
                    )}
                </div>
            </Fade>
            <style jsx>
                {`
                    #panel {
                        background-image: url('/assets/graphics/cp3-bg.png');
                        background-size: cover;
                        padding: 48px 60px;
                    }
                    #panel-content {
                        padding: 40px;
                        border-radius: 20px;
                        text-align: center;
                        max-width: 800px;
                        margin: 0 auto;
                        color: #fff !important;
                        background-color: #121651;
                    }
                    @media (max-width: 992px) {
                        #panel {
                            padding: 48px 40px;
                        }
                    }
                    @media (max-width: 480px) {
                        #panel {
                            padding: 30px 20px;
                        }
                    }
                `}
            </style>
        </div>
    );
};
